import {useContext} from 'react'

import Context from '@s-ui/react-context'

const COOKIES_MANAGEMENT_LINK = {
  title: 'FOOTER.LINK.MANAGE_COOKIES',
  url: '#'
}

const SECURITY_LINK = {
  text: 'FOOTER.SECURITY.TEXT',
  title: 'FOOTER.SECURITY.TITLE',
  url: 'https://adevinta.com/security-vulnerability/',
  arialabel: 'FOOTER.SECURITY.ARIA_LABEL'
}

export const AdevintaLinks = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {adevintaSites, POLICIES_LINKS} = config.get('footer')
  const COMPANY_NAME = config.get('COMPANY_NAME')
  const copyright = `© ${new Date().getFullYear()} ${i18n.t('FOOTER.BOTTOM.COPYRIGHT')}: `

  return (
    <div className="mt-SharedCorporateFooter-adevintaInfo">
      <p className="mt-SharedCorporateFooter-textContainer">
        <span
          dangerouslySetInnerHTML={{
            __html: i18n.t('FOOTER.BOTTOM.OTHER_SITES', {
              companyName: COMPANY_NAME
            })
          }}
        />
        {` `}
        <span className="mt-SharedCorporateFooter-linksContainer">
          {adevintaSites.map(({href, content}) => (
            <a key={content} target="_blank" href={href}>
              {content}
            </a>
          ))}
        </span>
      </p>

      <p className="mt-SharedCorporateFooter-textContainer">
        {copyright}
        <span className="mt-SharedCorporateFooter-linksContainer">
          {POLICIES_LINKS.map(policy => (
            <a key={policy.title} href={policy.url}>
              {i18n.t(policy.title)}
            </a>
          ))}
          <a
            href={SECURITY_LINK.url}
            aria-label={i18n.t(SECURITY_LINK.arialabel)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {i18n.t(SECURITY_LINK.text)}
          </a>
          <a href={COOKIES_MANAGEMENT_LINK.url} data-open-cmp-modal="true">
            {i18n.t(COOKIES_MANAGEMENT_LINK.title)}
          </a>
        </span>
      </p>
    </div>
  )
}
